<template>
  <div class="home">
    <!-- <img src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <Conteudo />
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Conteudo from '@/components/Conteudo.vue'
export default {
  name: 'home',
  components: {
    // HelloWorld,
    Conteudo
  }
}
</script>